<div class="review">
  <div class="row align-items-center">
    <div class="col-12">
      <h1 class="reviewer-name">{{name}}</h1>
      <h2 class="experience-name">{{experienceName}}</h2>
      <div class="rating">
        <ngx-rating [rate]="rating" [max]="max"></ngx-rating>
      </div>
      <p class="review-description">{{comment}}</p>
    </div>
  </div>
</div>
